export default __webpack_public_path__ + "static/media/cTrader.be50b39b.png";